import React, { useEffect } from 'react';

const ModalPopup = ({
  alertIcon,
  alertClassname,
  header,
  headerClassname,
  body,
  bodyClassname,
  footer,
  footerClassname,
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  });

  return (
    <>
      <img
        className="top_left_bg_logo hidden md:block"
        alt="top left background"
      />
      <img
        className="bottom_left_bg_logo hidden md:block"
        alt="bottom left background"
      />
      <img
        className="top_right_bg_logo hidden md:block"
        alt="top right background"
      />
      <img
        className="bottom_right_bg_logo hidden md:block"
        alt="bottom right background"
      />
      <div
        className="relative z-50"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="vf-ds-modal-overlay fixed inset-0 bg-black/45 transition-opacity backdrop-blur-[2px]"></div>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="vf-ds-modal-card relative transform overflow-hidden rounded-xl text-left shadow-xl transition-all duration-300 ease-out sm:my-8 sm:w-full sm:max-w-md m-auto p-6">
              {alertIcon && (
                <div className={alertClassname}>
                  <img
                    src={alertIcon}
                    data-testid="alert-icon"
                    alt="alert-icon"
                  />
                </div>
              )}
              {header && (
                <div
                  className={`${headerClassname || ''} vf-ds-modal-title font-semibold`}
                >
                  {header}
                </div>
              )}
              {body && (
                <div className={bodyClassname}>
                  <p className="text-sm text-[color:var(--vf-muted,#97a7b3)]">
                    {body}
                  </p>
                </div>
              )}
              {footer && <div className={footerClassname}>{footer}</div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalPopup;
